import {
  put
} from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* getAdvancedSecurityThreatsSaga(action) {
  //console.log('ADV SEC GETSecurity Log')
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  // console.log('Actions ::::', action)
  if(action.refreshData){
    yield put(actions.setAdvancedSecurityThreatsRefreshEnable());
  }


  if (sessionToken) {
          yield put(actions.getSecurityThreatsStart());

    let endpoint;
    if(action.isClicked){
      endpoint = 'advancedSecurity/threatsclick'
    }else{
      endpoint = 'advancedSecurity/threats'
    }
    try {

      let response = {};

      response = yield axios.get(
        endpoint,
        {
          params : {
            MAC:rMac,
            page: 0,
            maxDaysOld:action.maxDaysOld ? action.maxDaysOld : 1,
            size: 1000,
            // size:action.size ? action.size : '',
          }
        }
      )
      // console.log('security threats log :::', response);
      if(response.status === 200){
        if(action.maxDaysOld !==30){
          response.data.oneDayTotal = response.data.totalElements
        }

        yield put(actions.setAdvancedSecurityThreats(response.data))
        yield put(actions.setAdvancedSecurityThreatsSuccess());
      }else{
        yield put(actions.setAdvancedSecurityThreatsFailed());
      }

    } catch (error) {
      yield put(actions.setAdvancedSecurityThreatsFailed());
    }
  } else {
    // console.log('NO TOKEN')
    yield put(actions.setAdvancedSecurityThreatsFailed());
  }

}

export function* initSecurityLogInfoSaga(action) {
  //console.log('log info')
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  // console.log('Actions ::::', action)

  if (sessionToken) {

    try {
      let response = {};

      response = yield axios.get(
        'advancedSecurity/infotext'
      )
      if(response.status === 200){
        yield put(actions.setSecurityLogInfo(response.data))

      }

    } catch (error) {
    }
  }

}
